// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__qCTUv","label":"Radio_label__3MaY6","icon":"Radio_icon__2lXP0"};